import { useRef, useState } from "react";
import { CheckCircle2, IdCard, Loader2, ScanFace } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { shrinkImage } from "@/lib/boyCourier";
import { cn } from "@/lib/utils";

export function DocUpload({ code, kind, label, hint, value, onChange, pdf, selfie }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const raw = e.target.files?.[0];
    e.target.value = "";
    if (!raw) return;
    setBusy(true);
    try {
      const file = await shrinkImage(raw);
      if (file.size > 10 * 1024 * 1024) return toast.error("O arquivo deve ter no máximo 10 MB");
      const fd = new FormData();
      fd.append("kind", kind);
      fd.append("file", file);
      const { data } = await api.post(`/public/boy/${code}/couriers/upload`, fd);
      onChange({ ...data, preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : "" });
    } catch (x) {
      toast.error(errMsg(x));
    } finally {
      setBusy(false);
    }
  };
  const Icon = selfie ? ScanFace : IdCard;
  const shown = value?.preview;
  return (
    <div>
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} data-testid={`boy-doc-${kind}`}
        className={cn("relative flex aspect-[4/3] w-full flex-col items-center justify-center gap-1.5 overflow-hidden rounded-xl border-2 border-dashed p-3 text-center transition-colors",
          value ? "border-emerald-500/70 bg-emerald-500/5" : "border-border hover:border-primary hover:bg-primary/5")}>
        {shown && <img src={value.preview} alt={label} className="absolute inset-0 h-full w-full object-cover" data-testid={`boy-doc-${kind}-preview`} />}
        {busy && <Loader2 className="relative h-7 w-7 animate-spin text-primary" />}
        {!busy && !shown && (value ? <CheckCircle2 className="h-8 w-8 text-emerald-600" /> : <Icon className="h-8 w-8 text-muted-foreground" />)}
        {!shown && <span className="text-sm font-semibold">{label}</span>}
        {!shown && <span className="text-xs text-muted-foreground">{busy ? "Enviando..." : value ? "Arquivo enviado · toque para trocar" : hint}</span>}
        {shown && (
          <span className="absolute inset-x-0 bottom-0 flex items-center justify-between gap-2 bg-black/65 px-3 py-1.5 text-xs font-medium text-white">
            <span className="flex min-w-0 items-center gap-1 truncate"><CheckCircle2 className="h-3.5 w-3.5 shrink-0 text-emerald-400" />{label}</span><span>Trocar</span>
          </span>
        )}
      </button>
      <input ref={ref} type="file" accept={pdf ? "image/*,application/pdf" : "image/*"} capture={selfie ? "user" : undefined} className="hidden" onChange={pick} data-testid={`boy-doc-${kind}-input`} />
    </div>
  );
}
